import React from 'react'
import { useTheme } from '@material-ui/core/styles'

import SpacerBar from '../../components/spacerBar'

export default function HomeBar(props) {
  const theme = useTheme()
  return <SpacerBar color={theme.palette.primary.main} />
}
